const pushHealthyStartsEvent = (eventName, payload) => {
  window.dataLayer = window.dataLayer || [];
  const eventData = { event: eventName, ...payload };
  window.dataLayer.push(eventData);

  const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
  const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
  console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, eventData);
};

const initHealthyStartsModalTriggers = () => {
  for (const trigger of document.querySelectorAll('[data-healthy-starts-modal-trigger]')) {
    if (trigger.dataset.hsModalBound === 'true') continue;
    trigger.dataset.hsModalBound = 'true';

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const modalId = trigger.getAttribute('data-healthy-starts-modal-trigger');
      if (!modalId) return;

      const modal = document.getElementById(modalId);
      if (!modal || typeof modal.show !== 'function') return;

      const productPath = trigger.getAttribute('data-product-url') || '';
      pushHealthyStartsEvent('click', {
        Product: productPath,
        source: 'upsell_component'
      });

      modal.show();
    });
  }
};

const initHealthyStartsModalEvents = () => {
  for (const modal of document.querySelectorAll('modal-box.hs-modal')) {
    if (modal.dataset.hsModalEventsBound === 'true') continue;
    modal.dataset.hsModalEventsBound = 'true';

    const primaryCta = modal.querySelector('[data-hs-modal-primary-cta]');
    if (primaryCta) {
      primaryCta.addEventListener('click', () => {
        const destinationUrl = primaryCta.getAttribute('href') || '';
        pushHealthyStartsEvent('click', {
          destination_url: destinationUrl,
          source: 'upsell_component'
        });
      });
    }

    for (const closeControl of modal.querySelectorAll('[data-hs-modal-close-action]')) {
      closeControl.addEventListener('click', () => {
        pushHealthyStartsEvent('click', {
          action: 'close',
          source: 'upsell_component'
        });
      });
    }
  }
};

const initHealthyStartsModalTracking = () => {
  initHealthyStartsModalTriggers();
  initHealthyStartsModalEvents();
};

document.addEventListener('DOMContentLoaded', initHealthyStartsModalTracking);
document.addEventListener('shopify:section:load', initHealthyStartsModalTracking);
